import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useResponsive } from 'hooks/useResponsive'
import { editorSelectors } from 'store/features/editor/selectors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const useIsTabActive = () => {
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)
  const activeTabKey = useSelector(editorSelectors.activeSidebarTab)
  const activeAsideOverlayKey = useSelector(
    editorSelectors.activeAsideOverlayKey
  )
  const isMobileSubSidebarOpen = useSelector(
    editorSelectors.isMobileSubSidebarOpen
  )

  const isTabActive = useCallback(
    (tabKey: string) => {
      const isTabActiveWithoutOverlay =
        !activeAsideOverlayKey && activeTabKey === tabKey

      if (isMobile) {
        return isTabActiveWithoutOverlay && isMobileSubSidebarOpen
      }

      return isTabActiveWithoutOverlay
    },
    [activeAsideOverlayKey, activeTabKey, isMobile, isMobileSubSidebarOpen]
  )

  return isTabActive
}
